import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { ModalComponent } from "../modal/modal.component";

@Component({
  selector: "app-dialog-force",
  templateUrl: "./force.component.html",
  styleUrl: "./force.component.less",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule, MatIconModule],
})
export class ForceComponent extends ModalComponent {
  public constructor() {
    super();
  }
}
